import {Component, OnInit, HostListener, ViewChild, AfterViewInit} from '@angular/core';
import {DashboardService} from './dashboard.service';
import {DashboardTileModel} from '../shared/model/dashboard-tile-model';
import {noop} from 'rxjs';
import {BaseComponent} from '../shared/components/base.component';
import {TokenService} from '../shared/service/token.service';
import { ApplicationModalComponent } from './application-modal/application-modal.component';
import { AuthorizationService } from '../shared/service/authorization.service';
import {LicenseAgreementService} from "../license/license-agreement.service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DashboardService]
})
export class DashboardComponent extends BaseComponent implements OnInit, AfterViewInit {

  @ViewChild(ApplicationModalComponent) applicationModal: ApplicationModalComponent;

  public tiles: DashboardTileModel[];
  public activeTile: DashboardTileModel;
  public isLoading: boolean;

  constructor(
    private dashboardService: DashboardService,
    private tokenService: TokenService,
    private authorizationService: AuthorizationService,
    private licenseService: LicenseAgreementService,
  ) {
    super();
  }

  ngOnInit() {
    this.licenseService.enforceLicenseAgreement();
    this.loadApplications();
  }

  ngAfterViewInit(): void {
    window.dispatchEvent(new Event("resize")); //fix for mdb navbar size
  }

  public getUsername(): string {
    return `${this.tokenService.getFirstName()} ${this.tokenService.getLastName()}`;
  }

  public getUserEmail(): string {
    return this.tokenService.getUsername();
  }

  public getUserFirstName() {
    return this.tokenService.getFirstName();
  }

  private loadApplications() {
    this.isLoading = true;
    this.dashboardService.getApplications(false).subscribe(
      result => {
        this.tiles = result;
        if (this.tiles.length === 1 && this.tokenService.getLicenseAgreed()) {
          const win: Window = window;
          win.location = this.tiles[0].url;
        }
        if (this.tiles.length > 0)
          this.activeTile = this.tiles[0];
        
      },
      noop, () => this.isLoading = false
      );
  }

  public onTileClick(tile: DashboardTileModel) {
    this.activeTile = tile;
  }

  public activateApplication(appliactionType: string) {
    this.isLoading = true;
    this.dashboardService.activateApplication(appliactionType).subscribe(result =>
      {
        this.authorizationService.refreshTokensIfNeeded();
        this.loadApplications();
        window.open(result.url, '_blank');
      }, () => this.isLoading = false, () => this.isLoading = false);
  }
}
